
import { $AjaxJson } from '@/lf'
import { $Urlpath, $UrlApipath } from '@/config/config'
export const ColorMarkRequest = {

    GetColorMark(func, ID) {
        $AjaxJson($UrlApipath + "System/GetColorMark", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddColorMark(func, obj) {
        $AjaxJson($UrlApipath + "System/AddColorMark", obj, function (d) {
            func(d)
        })
    },
    UpdateColorMark(func, obj) {
        $AjaxJson($UrlApipath + "System/UpdateColorMark", obj, function (d) {
            func(d)
        })
    },
    SearchColorMark(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchColorMark", obj, function (d) {
            func(d)
        })
    },
    SearchColorMarkList(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchColorMarkList", obj, function (d) {
            func(d)
        })
    },
    DeleteColorMark(func, ID) {
        $AjaxJson($UrlApipath + "System/DeleteColorMark", { ID: ID }, function (d) {
            func(d)
        })
    },

}



// WEBPACK FOOTER //
// ./src/request/ColorMark.js